import { Operation, OPERATION_SOURCE_TYPE } from "@forgepoint/shared";

/**
 * Labels where an operation is performed.
 * @param operation - The operation to label
 * @returns "Outside" for outsourced operations, "Inside" otherwise
 */
export function operationSourceLabel(operation: Operation): string {
  return operation.operationSourceType === OPERATION_SOURCE_TYPE.OUTSIDE
    ? "Outside"
    : "Inside";
}
